import moment from "moment";
import React, { useEffect, useState } from "react";

const NavigationTimer = ({ event_start_date }) => {

  const event_start_time =
    moment(event_start_date).format("YYYY-MM-DD") + " " + "00:00:00";

  const event_start = new Date(event_start_time).getTime();

  const [day, setDay] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [second, setSecond] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = event_start - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      setDay(days);

      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      setHour(hours);

      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      setMinute(minutes);

      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setSecond(seconds);
    });

    return () => clearInterval(interval);
  }, [event_start]);

  return (
    <>
      {second > 0 ? (
        <>
          <div className="timeStamp-text-icon">
            <i className="mt-1 me-2 far fa-clock"></i>
          </div>

          <p className="mt-1">
            {day > 0 ? `${day} days ` : ""}
            {hour > 0 ? `${hour} hrs ` : ""}
            {day < 1 && minute > 0 ? `${minute} min ` : ""}
            {day < 1 && hour < 1 && second > 0 ? `${second} sec` : ""}
          </p>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default NavigationTimer;
